<template>
  <el-row>
    <el-row
      v-if="isShow"
      class="dataView_advanceSearch"
    >
      <el-form
        ref="searchform"
        :model="searchform"
        label-width="0"
      >
        <h4>添加查询条件</h4>
        <el-row
          v-for="(item,index) in searchform.queryConditions"
          :key="index"
        >
          <el-col :span="6">
            <el-form-item
              :prop="'queryConditions.'+index+'.column'"
              :rules="{required: true, message: '所选内容不能为空', trigger: 'change'}"
            >
              <el-select
                v-model="item.column"
                placeholder="请选择查询字段"
                clearable
                filterable
              >
                <el-option
                  v-for="item in searchList"
                  :key="item.name"
                  :label="item.comment"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :prop="'queryConditions.'+index+'.type'"
              :rules="{required: true, message: '所选内容不能为空', trigger: 'change'}"
            >
              <el-select
                v-model="item.type"
                placeholder="请选择查询条件"
                clearable
              >
                <el-option
                  v-for="item in judgeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  filterable
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="item.type!=''&&item.type!='NOTNULL'&&item.type!='ISNULL'"
            :span="6"
          >
            <el-form-item
              :prop="'queryConditions.'+index+'.value'"
              :rules="{required: true, message: '所输内容不能为空', trigger: 'change'}"
            >
              <el-input
                v-model="item.value"
                placeholder="请输入内容"
                clearable
              />
            </el-form-item>
          </el-col>
          <i
            class="el-icon-circle-plus opbtn"
            @click="handleOperation('plus',index)"
          />
          <i
            class="el-icon-remove-outline opbtn"
            @click="handleOperation('remove',index)"
          />
        </el-row>
      </el-form>
      <el-form
        ref="sortform"
        :model="sortform"
        label-width="0"
      >
        <h4>添加排序条件</h4>
        <el-row
          v-for="(item,index) in sortform.orderConditions"
          :key="'info'+index"
        >
          <el-col :span="6">
            <el-form-item
              :prop="'orderConditions.'+index+'.orderColumn'"
              :rules="{required: true, message: '所选内容不能为空', trigger: 'change'}"
            >
              <el-select
                v-model="item.orderColumn"
                placeholder="请选择排序字段"
                clearable
              >
                <el-option
                  v-for="item in searchList"
                  :key="item.name"
                  :label="item.comment"
                  :value="item.name"
                  filterable
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :prop="'orderConditions.'+index+'.type'"
              :rules="{required: true, message: '所选内容不能为空', trigger: 'change'}"
            >
              <el-select
                v-model="item.type"
                placeholder="请选择排序规则"
                clearable
              >
                <el-option
                  v-for="item in sortList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  filterable
                />
              </el-select>
            </el-form-item>
          </el-col>
          <i
            class="el-icon-circle-plus opbtn"
            @click="handleSort('plus',index)"
          />
          <i
            class="el-icon-remove-outline opbtn"
            @click="handleSort('remove',index)"
          />
        </el-row>
      </el-form>
      <el-row class="searchbtn">
        <el-button
          round
          type="primary"
          size="small"
          @click="handleSearch"
        >查询</el-button>
        <el-button
          round
          type="primary"
          size="small"
          @click="handleCancel('reset')"
        >重置</el-button>
        <el-button
          v-show="type!='resultSearch'"
          round
          size="small"
          @click="handleCancel('cancel')"
        >取消</el-button>
      </el-row>
    </el-row>
    <!-- 表头动态获取 -->
    <el-table
      v-loading="loading"
      v-show="type!='resultSearch'"
      :data="tableData"
      class="outTable"
    >
      <el-table-column
        v-for="item in fatherBillColumns"
        :key="item.name"
        :prop="item.name"
        :label="item.comment"
        min-width="120"
      />
      <el-table-column
        v-for="(val,key,index) in sonColumns[0]"
        v-show="sonColumns.length>0"
        :key="key"
        :label="'子表单'+Number(index+1)"
        min-width="80"
      >
        <!-- 如果有子表单就显示按钮，没有就不显示 -->
        <template slot-scope="scope">
          <el-button
            size="small"
            @click.native.prevent="showDialog(index+1,sonColumns[scope.$index][key])"
          >
            子表单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="type!='resultSearch'"
      :current-page="pages.pageNum"
      :page-size="pages.pageSize"
      :total="total"
      layout="total, prev, pager, next, jumper"
      @current-change="handleCurrentChange"
    />
    <!-- 子表单 -->
    <el-drawer
      :title="`子表单${sonIndex}`"
      :visible.sync="dialogTableVisible"
      append-to-body
      destroy-on-close
      class="subform_drawer"
    >
      <el-table :data="gridData">
        <el-table-column
          v-for="item in childrenBillColumns"
          :key="item.name"
          :prop="item.name"
          :label="item.comment"
          min-width="120"
        />
      </el-table>
    </el-drawer>
    <!-- <el-dialog :title="`子表单${sonIndex}`" width="700px" :visible.sync="dialogTableVisible" :modal="false" :close-on-click-modal="false">
      <el-table :data="gridData">
        <el-table-column v-for="item in childrenBillColumns" :key="item.name" :prop="item.name" :label="item.comment" min-width="120">
        </el-table-column>
      </el-table>
    </el-dialog> -->
  </el-row>
</template>
<script>
import { getDataviewInfo, getFieldsByYYID, getresultCondition } from './fill'
import { getCondition, getFields, getQueryInfo } from './myShare'
export default {
  name: 'AdvanceSearch',
  props: ['isShow', 'type', 'yyid', 'shareId', 'queryCondition', 'taskId'],
  data () {
    return {
      loading: false,
      searchList: [],
      judgeList: [
        {
          label: '等于',
          value: 'EQUALSIGN'
        },
        {
          label: '不等于',
          value: 'NOTEQUALSIGN'
        },
        {
          label: '大于',
          value: 'GREATERSIGN'
        },
        {
          label: '大于等于',
          value: 'GREATEREQUALSIGN'
        },
        {
          label: '小于',
          value: 'LESSSIGN'
        },
        {
          label: '小于等于',
          value: 'LESSEQUALSIGN'
        },
        {
          label: '包含',
          value: 'INCLUDE'
        },
        {
          label: '开头为',
          value: 'STARTWITH'
        },
        {
          label: '结尾为',
          value: 'ENDWITH'
        },
        {
          label: '为空',
          value: 'ISNULL'
        },
        {
          label: '非空',
          value: 'NOTNULL'
        }
      ],
      sortList: [
        {
          label: '顺序',
          value: 'ASC'
        }, {
          label: '倒序',
          value: 'DESC'
        }
      ],
      searchform: {
        queryConditions: [{
          column: '',
          type: '',
          value: ''
        }]
      },
      sortform: {
        orderConditions: [{
          orderColumn: '',
          type: ''
        }]
      },
      tableData: [],
      fatherBillColumns: [],
      childrenBillColumns: [],
      sonColumns: [],
      sonIndex: 1,
      pages: {
        pageIndex: 1,
        pageSize: 10
      },
      total: 0,
      // subTotal: 10,
      dialogTableVisible: false,
      gridData: [],
      keyWord: '',
      queryObj: this.queryCondition
    }
  },
  created () {
    // 预览筛选结果
    this.getCondition()
    this.getFields()
  },
  methods: {
    // 获取分享详情(我的分享,业务管理中心,预览筛选结果)
    getCondition () {
      this.loading = true
      let tempObj = {}
      if (this.searchform.queryConditions[0].column === '' && this.sortform.orderConditions[0].orderColumn !== '') {
        tempObj = { ...this.sortform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = [...this.sortform.orderConditions]
          this.queryObj.queryConditions = []
        }
      } else if (this.searchform.queryConditions[0].column !== '' && this.sortform.orderConditions[0].orderColumn === '') {
        tempObj = { ...this.searchform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = []
          this.queryObj.queryConditions = [...this.searchform.queryConditions]
        }
      } else if (this.searchform.queryConditions[0].column !== '' && this.sortform.orderConditions[0].orderColumn !== '') {
        tempObj = { ...this.searchform, ...this.sortform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = [...this.sortform.orderConditions]
          this.queryObj.queryConditions = [...this.searchform.queryConditions]
        }
      } else {
        tempObj = {}
        if (this.queryCondition) {
          this.queryObj.orderConditions = []
          this.queryObj.queryConditions = []
        }
      }
      if (this.type === 'shareSearch') {
        getCondition({ ...this.pages, ...{ shareId: this.shareId, keyWord: this.keyWord, condition: tempObj } }).then(res => {
          this.loading = false

          if (res.data.length > 0) {
            // 主表
            // 表头
            this.fatherBillColumns = res.data[0].father.fatherBillColumns
            this.total = res.count
            this.pages.pageNum = res.pageNum
            // 数据
            this.tableData = []
            this.sonColumns = []
            res.data.forEach((item, index) => {
              this.tableData.push({})
              item.father.fatherBillColumns.forEach(fItem => {
                this.tableData[index][fItem.name] = item.father.fatherBillData[fItem.name]
              })
              // 子表
              this.sonColumns.push(item.son)
            })
          } else {
            this.fatherBillColumns = []
            this.sonColumns = []
            this.total = res.count
            this.pages.pageNum = res.pageNum
          }
        }).catch(res => {
          this.loading = false
        })
      } else if (this.type === 'yySearch') {
        getDataviewInfo({ ...this.pages, ...{ yyid: this.yyid, keyWord: this.keyWord, condition: tempObj } }).then(res => {
          this.loading = false

          if (res.data.length > 0) {
            // 主表
            // 表头
            this.fatherBillColumns = res.data[0].father.fatherBillColumns
            this.total = res.count
            this.pages.pageIndex = res.pageIndex
            // 数据
            this.tableData = []
            this.sonColumns = []
            res.data.forEach((item, index) => {
              this.tableData.push({})
              item.father.fatherBillColumns.forEach(fItem => {
                this.tableData[index][fItem.name] = item.father.fatherBillData[fItem.name]
              })
              // 子表
              this.sonColumns.push(item.son)
            })
          } else {
            this.fatherBillColumns = []
            this.sonColumns = []
            this.total = res.count
            this.pages.pageIndex = res.pageIndex
          }
        }).catch(res => {
          this.loading = false
        })
      } else if (this.type === 'resultSearch') {
        getresultCondition({ ...this.pages, ...{ taskId: this.taskId, yyid: this.yyid, condition: tempObj } }).then(res => {
          this.loading = false

          if (res.data.length > 0) {
            // 主表
            // 表头
            this.fatherBillColumns = res.data[0].father.fatherBillColumns
            this.total = res.count
            this.pages.pageNum = res.pageNum
            // 数据
            this.tableData = []
            this.sonColumns = []
            res.data.forEach((item, index) => {
              this.tableData.push({})
              item.father.fatherBillColumns.forEach(fItem => {
                this.tableData[index][fItem.name] = item.father.fatherBillData[fItem.name]
              })
              // 子表
              this.sonColumns.push(item.son)
            })
          } else {
            this.fatherBillColumns = []
            this.sonColumns = []
            this.total = res.count
            this.pages.pageNum = res.pageNum
          }
        }).catch(res => {
          this.loading = false
        })
      } else {
        // //预览筛选结果
        getQueryInfo({ ...this.pages, ...{ yyid: this.yyid }, condition: this.queryObj }).then(res => {
          this.loading = false

          if (res.data.length > 0) {
            // 主表
            // 表头
            this.fatherBillColumns = res.data[0].father.fatherBillColumns
            this.total = res.count
            this.pages.pageNum = res.pageNum
            // 数据
            this.tableData = []
            this.sonColumns = []
            res.data.forEach((item, index) => {
              this.tableData.push({})
              item.father.fatherBillColumns.forEach(fItem => {
                this.tableData[index][fItem.name] = item.father.fatherBillData[fItem.name]
              })
              // 子表
              this.sonColumns.push(item.son)
            })
          } else {
            this.fatherBillColumns = []
            this.sonColumns = []
            this.total = res.count
            this.pages.pageNum = res.pageNum
          }
        }).catch(res => {
          this.loading = false
        })
      }
    },
    handleCurrentChange (val) {
      this.pages.pageNum = val
      this.getCondition()
    },
    // 查看子表单
    showDialog (index, data) {
      console.log(index)
      this.sonIndex = index
      this.gridData = []
      if (data.childrenBillColumns.length > 0) {
        // 主表
        // 表头
        this.childrenBillColumns = data.childrenBillColumns
        // 数据
        data.childrenBillData.forEach((item, index) => {
          this.gridData.push({})
          data.childrenBillColumns.forEach(fItem => {
            this.gridData[index][fItem.name] = item[fItem.name]
          })
        })
      }
      this.dialogTableVisible = true
    },
    // 获取查询字段和排序字段
    getFields () {
      if (this.type === 'shareSearch') {
        getFields(this.shareId).then(res => {
          this.searchList = res.data
        })
      } else {
        getFieldsByYYID(this.yyid).then(res => {
          this.searchList = res
        })
      }
    },
    // 关键词搜索
    search (param) {
      this.keyWord = param
      this.getCondition()
    },
    // 高级查询
    handleSearch () {
      let tempObj = {}
      if (this.searchform.queryConditions[0].column === '' && this.sortform.orderConditions[0].orderColumn !== '') {
        tempObj = { ...this.sortform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = [...this.sortform.orderConditions]
          this.queryObj.queryConditions = []
        }
      } else if (this.searchform.queryConditions[0].column !== '' && this.sortform.orderConditions[0].orderColumn === '') {
        tempObj = { ...this.searchform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = []
          this.queryObj.queryConditions = [...this.searchform.queryConditions]
        }
      } else if (this.searchform.queryConditions[0].column !== '' && this.sortform.orderConditions[0].orderColumn !== '') {
        tempObj = { ...this.searchform, ...this.sortform }
        if (this.queryCondition) {
          this.queryObj.orderConditions = [...this.sortform.orderConditions]
          this.queryObj.queryConditions = [...this.searchform.queryConditions]
        }
      } else {
        tempObj = {}
        if (this.queryCondition) {
          this.queryObj.orderConditions = []
          this.queryObj.queryConditions = []
        }
      }
      if (this.searchform.queryConditions[0].column !== '' || this.searchform.queryConditions[0].type !== '' || this.searchform.queryConditions[0].value !== '') {
        this.$refs['searchform'].validate((valid) => {
          if (valid) {
            if (this.type === 'resultSearch') {
              console.log('554', tempObj)
              this.$emit('condition', tempObj)
            } else {
              this.getCondition()
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        if (this.sortform.orderConditions[0].orderColumn !== '' || this.sortform.orderConditions[0].type !== '') {
          this.$refs['sortform'].validate((valid) => {
            if (valid) {
              this.getCondition()
            } else {
              console.log('error submit!!')
              return false
            }
          })
        } else {
          if (this.type === 'resultSearch') {
            this.$emit('condition', tempObj)
          } else {
            this.getCondition()
          }
        }
      }
      // if (this.type === 'resultSearch') {
      //   this.$emit('close', false)
      // }
    },

    handleSort (type, index) {
      if (type === 'plus') {
        this.$refs['sortform'].validate((valid) => {
          if (valid) {
            this.sortform.orderConditions.push({
              orderColumn: '',
              type: ''
            })
          } else {
            return false
          }
        })
      } else {
        if (this.sortform.orderConditions.length > 1) {
          this.sortform.orderConditions.splice(index, 1)
        } else {
          this.$message({
            message: '只剩一条数据了，不能再删了！',
            type: 'warning'
          })
        }
      }
    },
    handleOperation (type, index) {
      if (type === 'plus') {
        this.$refs['searchform'].validate((valid) => {
          if (valid) {
            this.searchform.queryConditions.push({
              column: '',
              type: '',
              value: ''
            })
          } else {
            return false
          }
        })
      } else {
        if (this.searchform.queryConditions.length > 1) {
          this.searchform.queryConditions.splice(index, 1)
        } else {
          this.$message({
            message: '只剩一条数据了，不能再删了！',
            type: 'warning'
          })
        }
      }
    },

    handleCancel (type) {
      this.searchform = {
        queryConditions: [{
          column: '',
          type: '',
          value: ''
        }]
      }
      this.sortform = {
        orderConditions: [{
          orderColumn: '',
          type: ''
        }]
      }
      if (type === 'cancel') {
        this.$emit('cancel')
        this.getCondition()
      }
    }
  }
}
</script>
<style lang="scss">
.dataView {
  &_advanceSearch {
    border: 2px solid #eee;
    // margin: 20px 50px;
    padding: 0 20px 20px;
    h4 {
      margin-top: 15px;
      font-size: 14px;
      color: rgba(2, 21, 37, 0.65);
    }
    .el-row {
      margin-top: 15px;
      display: flex;
      align-items: center;
      .el-col {
        margin-right: 10px;
      }
      .opbtn {
        font-size: 32px;
        color: #3394e1;
        margin-right: 5px;
        &:hover {
          cursor: pointer;
        }
      }
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .el-select,
    .el-input__inner {
      width: 100%;
    }
  }
}
.subform_drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6ecf2;
  }
}
</style>
